import { useCallback } from "react";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";

export default function useRedirectToZadostDetail() {
  const redirect = useRedirect();

  return useCallback(
    id => {
      redirect(PATHS.ZADOSTI.DETAIL, { id });
    },
    [redirect]
  );
}
